import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { StaticDevicesFilters } from '@/api/routes/static-devices/types';
import type { StaticAdFilters } from '@/api/routes/static-stat/types';

import { fetchStaticAdFilters } from './actionCreators';
import { statStaticAdFilters } from './mocks';

interface InitialState {
  filters: StaticAdFilters,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  filters: statStaticAdFilters,
  isLoading: false,
  error: '',
};

export const staticDevicesFiltersSlice = createSlice({
  name: 'staticDevicesFilters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase<any, PayloadAction<StaticDevicesFilters>>(
      fetchStaticAdFilters.fulfilled,
      (state, action) => {
        state.isLoading = false;
        state.error = '';
        state.filters = {
          org: action.payload.org,
          adv: action.payload.adv,
        };
      },
    );
    builder.addCase(
      fetchStaticAdFilters.pending,
      (state) => {
        state.isLoading = true;
      },
    );
    builder.addCase<any, PayloadAction<string>>(
      fetchStaticAdFilters.rejected,
      (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      },
    );
  },
});

export default staticDevicesFiltersSlice.reducer;
